import _ from 'lodash';

import type { PermissionSystem } from './permission-system';
import type { PermissionTable } from './permission-types';

// TODO Make this private to the backend.

export type PermissionTypeEnum<P extends string> = Readonly<Record<P, number>>;

export type DbPermissionBase<A extends string> = Record<A, boolean> & {
	permission: number;
};

export interface PermissionDbHelpers<P extends string, A extends string> {
	readonly permissionTypeEnum: PermissionTypeEnum<P>;

	getPermissionName(id: number): P | undefined;
	getPermissionId(permissionType: P): number;
	getPermissionId(permissionType: string): number | undefined;

	serializePermissions(
		dbPermissions: DbPermissionBase<A>[] | null | undefined
	): PermissionTable<P, A>;
}

export function makePermissionDbHelpers<P extends string, A extends string>(
	system: PermissionSystem<P, A>,
	permissionTypeEnum: PermissionTypeEnum<P>
): PermissionDbHelpers<P, A> {
	function getPermissionName(id: number) {
		return _.findKey(permissionTypeEnum, _.partial(_.isEqual, id)) as
			P | undefined;
	}

	function getPermissionId(permissionType: P) {
		return permissionTypeEnum[permissionType];
	}

	function serializePermissions(
		dbPermissions: DbPermissionBase<A>[] | null | undefined
	): PermissionTable<P, A> {
		// this logic should be moved to some sort of serializer

		const permissions = {} as PermissionTable<P, A>;

		for (const dbPermission of dbPermissions ?? []) {
			const permissionName = getPermissionName(dbPermission.permission);
			if (typeof permissionName === 'string') {
				for (const a of system.actionTypes) {
					if (dbPermission[a]) {
						_.set(permissions, [permissionName, a], true);
					}
				}
			}
		}

		return permissions;
	}

	return {
		permissionTypeEnum,

		getPermissionName,
		getPermissionId,

		serializePermissions,
	};
}
